import ResponsiveBox from 'components/generic/ResponsiveBox.component';
import { MarketingContent } from 'components/onboarding/MarketingContent.component';

import CN from './OnboardingLayout.module.scss';

export const OnboardingLayout = ({ mobileHeader, children }) => (
  <div data-bem="OnboardingLayout" className={CN.component}>
    <div className={CN.layout}>
      <ResponsiveBox.Desktop>
        <div className={CN.header}>
          <MarketingContent />
        </div>
      </ResponsiveBox.Desktop>

      <ResponsiveBox.Mobile>{mobileHeader && <div className={CN.mobileHeader}>{mobileHeader}</div>}</ResponsiveBox.Mobile>

      <div className={CN.formArea}>{children}</div>
    </div>
  </div>
);
